<a *ngIf="!child.childCmsPages || child.childCmsPages.length == 0" [routerLink]="['/page', child.slug]"
    class="text-default">
    <span class="mr-3">
        <i class="material-icons">
            double_arrow</i>
    </span>
    <span>
        {{child.title}}
    </span>
</a>
<ul class="list-unstyled" *ngIf="child.childCmsPages && child.childCmsPages.length > 0">
    <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0">
        <ngb-panel cardClass="mb-2" id="panel-{{child.id}}">
            <ng-template ngbPanelHeader let-opened="opened">
                <div (click)="acc.toggle('panel-' + child.id)" class="d-flex justify-content-start" role="button">
                    <span class="mr-3">
                        <i class="material-icons">
                            {{ opened ? 'indeterminate_check_box' : 'local_hospital' }}
                        </i>
                    </span>
                    <span>{{ child.title }}</span>
                </div>
            </ng-template>
            <ng-template ngbPanelContent>
                <li *ngFor="let item of child.childCmsPages">
                    <app-child-item [child]="item">
                    </app-child-item>
                </li>
            </ng-template>
        </ngb-panel>
    </ngb-accordion>
</ul>